<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Forms</li>
        <li class="breadcrumb-item"><router-link :to="{name: 'forms'}">Records</router-link></li>
        <li class="breadcrumb-item active">{{ record.form_type | capitalize }} #{{ record.id }}</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-body">
        <h3 class="page-title">View form record #{{ record.id }}</h3>
      </div>
    </div>
    <div class="card">
      <div class="card-body" v-html="record.html_data"/>
    </div>
    <div class="card">
      <div class="card-body">
        <button type="button" class="btn btn-primary" @click="goBack">Back</button>
        <button v-if="record.status != 'new'" type="button" class="btn btn-success" @click="setStatus('new')">Mark as new</button>
        <button v-else type="button" class="btn btn-danger" @click="setStatus('viewed')">Mark as viewed</button>
        <a :href="'/admin/forms/print?id=' + record.id" class="btn btn-info" target="_blank">Print</a>
      </div>
    </div>
    <div v-if="record.files_list" class="card">
      <div class="card-header">
        <h3>Attached files</h3>
      </div>
      <div class="card-body" v-html="record.files_list"/>
    </div>
  </div>
</template>

<script>
/* global axios, toastr */
export default {
  name: 'FormsEdit',
  data () {
    return {
      record: {}
    }
  },
  beforeRouteEnter (to, from, next) {
    let route = '/api/admin/forms/' + to.params.formId
    axios.get(route)
      .then(repsonse => {
        next(vm => {
          vm.record = repsonse.data.form
        })
      })
      .catch(error => {
        console.log(error)
        next()
      })
  },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  beforeRouteUpdate (to, from, next) {
    console.log('update')
  },
  methods: {
    setStatus (status) {
      axios.post('/api/admin/forms/save', {
        form: this.record,
        status: status
      })
        .then(response => {
          if (response && response.data && response.data.result === 'ok') {
            this.record = response.data.form
            toastr['success']('Record has been saved successfully')
          } else {
            let message = (response && response.data && response.data.message) || 'Something goes wrong'
            toastr['error'](message)
          }
        })
        .catch(error => {
          let message = (error && error.message) || 'Something goes wrong'
          toastr['error'](message)
        })
    },
    goBack () {
      this.$router.push('/admin/forms')
    }
  }
}
</script>

<style>
</style>
